import logger from "../../lib/appfuse-react/core/logger";
import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";
import {Questionnaire} from "../../lib/appfuse-react/qnr";
import Sort from "../../lib/appfuse-react/core/Sort";

const LOGGER = logger.getLogger('processingApplicationReducer');

const name = 'processingApplicationDraft';

const initialState = {
    data: [],
    selection: null,
    pageNumber: 0,
    pageSize: 10,
    criteria: {},
    sort: null,
    drafts: {},
    nodeId: null,
    product: {},
    questionnaire: null,
    questionnaireChange: false,
    questionnaireValidations: [],
    cropSurvey: {},
    cropQuestionnaires: {},
    cropAttachments: {},
    cropAttachmentChange: null,
    cropperInfo: {},
    cropperInfoChange: {},
    activeStep: 0,
    soilActiveStep: 0,
    cropManageActiveStep: 0,
    maintainActiveStep: 0,
    recordActiveStep: 0,
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setData(state, action) {
            state.data = json.toJSON(action.payload);
        },
        setSelection(state, action) {
            state.selection = json.toJSON(action.payload);
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageSize(state, action) {
            state.pageSize = action.payload;
        },
        setCriteria(state, action) {
            state.criteria = json.toJSON(action.payload);
        },
        setSort(state, action) {
            state.sort = json.toJSON(action.payload);
        },
        setDrafts(state, action) {
            state.drafts = json.toJSON(action.payload);
        },
        setNodeId(state, action) {
            state.nodeId = action.payload;
        },
        setCertificationProduct(state, action) {
            state.product = json.toJSON(action.payload);
        },
        setQuestionnaire(state, action) {
            const questionnaire =  json.toJSON(action.payload);
            state.questionnaire = questionnaire;
        },
        setActiveStep(state, action) {
            state.activeStep = action.payload;
        },
        setQuestionnaireChange(state, action) {
            state.questionnaireChange = action.payload;
        },
        setCropSurvey(state, action) {
            state.cropSurvey = json.toJSON(action.payload);
        },
        setCropQuestionnaires(state, action) {
            state.cropQuestionnaires = json.toJSON(action.payload);
        },
        setCropAttachment(state, action) {
            state.cropAttachments = json.toJSON(action.payload);
        },
        setCropAttachmentChange(state, action) {
            state.cropAttachmentChange = json.toJSON(action.payload);
        },
        setCropperInfo(state, action) {
            state.cropperInfo = json.toJSON(action.payload);
        },
        setCropperInfoChange(state, action) {
            state.cropperInfoChange = json.toJSON(action.payload);
        },
        setSoilActiveStep(state, action) {
            state.soilActiveStep = action.payload;
        },
        setCropManageActiveStep(state, action) {
            state.cropManageActiveStep = action.payload;
        },
        setMaintainActiveStep(state, action) {
            state.maintainActiveStep = action.payload;
        },
        setRecordActiveStep(state, action) {
            state.recordActiveStep = action.payload;
        },
        setQuestionnaireValidations(state, action) {
            state.questionnaireValidations = action.payload;
        },
    }
});

export const {setData, setSelection, setPageNumber, setPageSize, setCriteria, setDrafts, setSort, setNodeId,
                setCertificationProduct, setQuestionnaire, setActiveStep, setQuestionnaireChange, setCropSurvey,
                setCropAttachment, setCropAttachmentChange, setCropperInfo, setCropperInfoChange,
                setCropQuestionnaires, setSoilActiveStep, setCropManageActiveStep, setMaintainActiveStep, setRecordActiveStep,
                setQuestionnaireValidations} = slice.actions;
const {reducer} = slice;

export const selectData = state => json.fromJSON(state[name].data);
export const selectCriteria = state => state[name].criteria;
export const selectSort = state => json.fromJSON(state[name].sort, Sort);
export const selectSelection = state => json.fromJSON(state[name].selection);
export const selectPageNumber = state => state[name].pageNumber;
export const selectPageSize = state => state[name].pageSize;
export const selectNodeId = state => state[name].nodeId;
export const selectDrafts = state => json.fromJSON(state[name].drafts);
export const selectApplicationDraft = (key) => (state) => selectDrafts(state)[key];
export const selectQuestionnaire = state => json.fromJSON(state[name].questionnaire, Questionnaire);
export const selectQuestionnaireChange = state => json.fromJSON(state[name].questionnaireChange);
export const selectQuestionnaireValidations = state => state[name].questionnaireValidations;
export const selectCertificationProduct = state => json.fromJSON(state[name].product);

export const selectCropSurvey = state => json.fromJSON(state[name].cropSurvey);
export const selectCropQuestionnaires = state => json.fromJSON(state[name].cropQuestionnaires);
export const selectCropQuestionnaire = (key) => state => selectCropQuestionnaires(state)[key];

export const selectCropAttachment = state => json.fromJSON(state[name].cropAttachments);
export const selectCropAttachmentChange = state => json.fromJSON(state[name].cropAttachmentChange);
export const selectCropperInfo = state => json.fromJSON(state[name].cropperInfo);
export const selectCropperInfoChange = state => json.fromJSON(state[name].cropperInfoChange);

export const selectActiveStep = state => state[name].activeStep;
export const selectSoilActiveStep = state => state[name].soilActiveStep;
export const selectCropManageActiveStep = state => state[name].cropManageActiveStep;
export const selectMaintainActiveStep = state => state[name].maintainActiveStep;
export const selectRecordActiveStep = state => state[name].recordActiveStep;

export const setApplicationDraft = (key, draft) => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    drafts[key] = draft;
    dispatch(setDrafts(drafts));
}

export const removeDraft = key => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    delete drafts[key];
    dispatch(setDrafts(drafts));
}

export const setCropQuestionnaire = (key, data) => (dispatch, getState) => {
    const questionnaires = selectCropQuestionnaires(getState());
    questionnaires[key] = {...questionnaires[key], ...data};
    dispatch(setCropQuestionnaires(questionnaires));
}

const processingApplicationDraftReducer = reducer;

export default processingApplicationDraftReducer;
